<div *ngIf="showSettings" class="car-page">
  <div class="car-panel grp-decorated-panel">

    <div class="car-panel__header grp-panel-header">
      <div class="car-panel__header-left">
        <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="22" height="22"
          style="margin-right: 10px; color: var(--brand-blue);">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <span class="grp-title-text">Paramètres du Thème</span>
      </div>
    </div>

    <ng-template #attente>
      <div class="settings-loader-container">
        <div class="spinner-circle spinner-circle--large"></div>
        <span class="settings-loader-text">Chargement des paramètres...</span>
      </div>
    </ng-template>

    <div class="car-panel__body settings-padding" *ngIf="!startLoading; else attente">
      <div class="settings-layout">

        <div class="settings-main-col">
          <form [formGroup]="objectThemeForm" (ngSubmit)="onSubmit()" class="settings-form">

            <div *ngFor="let key of objectThemeForm?.controls | keyvalue">

              <ng-container *ngIf="isArrayControl(key.key, key); else inputField">
                <div [formGroupName]="key.key" class="settings-section-card">
                  <h4 class="settings-section-title">{{ key.key }} <span class="settings-badge">List</span></h4>

                  <div *ngFor="let item of key.value.controls; let i = index" [formGroupName]="i"
                    class="settings-sub-card">
                    <div *ngFor="let subKey of item.controls | keyvalue" class="settings-input-wrapper">

                      <div class="grp-input-group"
                        *ngIf="!checkLength(subKey.key, key.key, i) && getInputType(subKey.key, key.key) !== 'checkbox'">
                        <label class="settings-label">{{ subKey.key }}</label>
                        <input class="grp-fancy-input" [formControlName]="subKey.key" id="{{ subKey.key }}"
                          [name]="subKey.key + '_' + i" [type]="getInputType(subKey.key, key.key)"
                          [placeholder]="'Saisir ' + subKey.key" />
                      </div>

                      <div class="grp-input-group"
                        *ngIf="checkLength(subKey.key, key.key, i) && getInputType(subKey.key, key.key) !== 'checkbox'">
                        <label class="settings-label">{{ subKey.key }}</label>
                        <textarea class="grp-fancy-input settings-textarea" [formControlName]="subKey.key"
                          id="{{ subKey.key }}" [name]="subKey.key + '_' + i" [placeholder]="'Saisir ' + subKey.key"
                          rows="3"></textarea>
                      </div>

                      <label class="settings-checkbox-wrapper" *ngIf="getInputType(subKey.key, key.key) === 'checkbox'">
                        <input type="checkbox" [formControlName]="subKey.key" [name]="subKey.key + '_' + i"
                          class="settings-checkbox-input">
                        <span class="settings-checkbox-custom"></span>
                        <span class="settings-checkbox-text">{{ subKey.key }}</span>
                      </label>

                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #inputField *ngIf="isFormGroup(objectThemeForm.get(key.key)); else nonGroup">
                <div [formGroupName]="key.key" class="settings-section-card">
                  <h4 class="settings-section-title">{{ key.key }} <span class="settings-badge">Composé</span></h4>

                  <div *ngFor="let subKey of objectThemeForm.get(key.key).controls | keyvalue"
                    class="settings-input-wrapper">
                    <ng-container>
                      <div class="grp-input-group" *ngIf="getInputType(subKey.key, key.key) !== 'checkbox'">
                        <label class="settings-label">{{ subKey.key }}</label>
                        <input class="grp-fancy-input" [formControlName]="subKey.key" id="{{ subKey.key }}"
                          [name]="key.key + '_' + subKey.key" [type]="getInputType(subKey.key, key.key)"
                          [placeholder]="'Saisir ' + subKey.key" [disabled]="subKey.key === 'name_website'" />
                      </div>

                      <label class="settings-checkbox-wrapper" *ngIf="getInputType(subKey.key, key.key) === 'checkbox'">
                        <input type="checkbox" [formControlName]="subKey.key" [name]="key.key + '_' + subKey.key"
                          class="settings-checkbox-input">
                        <span class="settings-checkbox-custom"></span>
                        <span class="settings-checkbox-text">{{ subKey.key }}</span>
                      </label>
                    </ng-container>
                  </div>
                </div>
              </ng-template>

              <ng-template #nonGroup>
                <ng-container *ngIf="checkInputsBeforeGenerate(key.key)">
                  <div class="settings-input-wrapper">
                    <div class="grp-input-group" *ngIf="getInputType(key.key) !== 'checkbox'">
                      <label class="settings-label">{{ key.key }}</label>
                      <input class="grp-fancy-input" [formControlName]="key.key" id="{{ key.key }}" [name]="key.key"
                        [type]="getInputType(key.key)" [placeholder]="'Saisir ' + key.key"
                        [disabled]="key.key === 'name_website'" />
                    </div>

                    <label class="settings-checkbox-wrapper" *ngIf="getInputType(key.key) === 'checkbox'">
                      <input type="checkbox" [formControlName]="key.key" [name]="key.key"
                        class="settings-checkbox-input">
                      <span class="settings-checkbox-custom"></span>
                      <span class="settings-checkbox-text">{{ key.key }}</span>
                    </label>
                  </div>
                </ng-container>
              </ng-template>

            </div>

            <div class="settings-submit-container">
              <button type="submit" class="grp-fancy-btn settings-btn-save" [disabled]="isSaving">
                <span class="spinner-circle" *ngIf="isSaving"></span>
                <span *ngIf="!isSaving">Enregistrer les modifications</span>
              </button>
            </div>

          </form>
        </div>

        <div class="settings-sidebar-col">
          <div class="settings-sidebar-card">
            <h2 class="settings-sidebar-title">
              <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
              Ajouter un Champ
            </h2>

            <div class="grp-input-group">
              <label class="settings-label">Nom de l'attribut</label>
              <input class="grp-fancy-input" id="newAttributeKey" name="newAttributeKey" [(ngModel)]="newAttributeKey"
                placeholder="..." />
            </div>

            <div class="grp-input-group" style="margin-top: 12px;">
              <label class="settings-label">Valeur initiale</label>
              <input class="grp-fancy-input" id="newAttributeValue" name="newAttributeValue"
                [(ngModel)]="newAttributeValue" placeholder="..." />
            </div>

            <button type="button" (click)="addNewAttribute()" class="grp-fancy-btn settings-btn-add"
              style="width: 100%; margin-top: 20px;" [disabled]="isSaving">
              <span class="spinner-circle" *ngIf="isSaving"></span>
              <span *ngIf="!isSaving">Ajouter l'attribut</span>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<app-access-to-settings *ngIf="!showSettings" (afterVerifAcess)="init()"></app-access-to-settings>